import React from "react";
import useTheme from "../../hooks/useTheme";

/**
 * The moon/sun button (design handoff ADDENDUM-8 §3).
 *
 * Sits in the market selector header beside ✕, and in the trading page's top
 * bar. It is hidden on the Pokédex trading page — that view is a physical
 * device with its own casing colours and is not themed.
 *
 * A 38px raised circle under the 2026 system: `--raise` on `--pillow-sm`, no
 * border — nothing gets both a pillow and a border. The glyph offers the mode
 * you are not in.
 *
 * @param {object} props
 * @param {object} [props.style] - Merged over the spec's box, for placement
 * @param {string} [props.className]
 */
export function ThemeToggle({ style, className = "" }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? "Switch to light theme" : "Switch to dark theme";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={`ce-theme-btn ${className}`.trim()}
      style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        width: 38, height: 38, borderRadius: 999,
        background: "var(--raise)",
        border: 0,
        boxShadow: "var(--pillow-sm)",
        color: "var(--ink-2)",
        fontSize: 15, cursor: "pointer", flexShrink: 0,
        ...style,
      }}
    >
      {isDark ? "☀" : "☾"}
    </button>
  );
}

export default ThemeToggle;
